import { observer } from 'mobx-react-lite';
import React, { FC } from 'react';

export const KitGridItemMobile: FC = observer(function KitGridItemMobile({ children }) {
  return <div className="col-3-sm mt-2 mb-2">{children}</div>;
});
